<article
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="idleNoticeTitle"
  class="tw-relative tw-flex tw-flex-col tw-bg-white"
>
  <h2 id="idleNoticeTitle" class="tw-mb-6 tw-text-2xl tw-font-semibold tw-text-gray-900">
    {{ 'idle_session.title' | translate }}
  </h2>

  <p class="tw-text-main-text" aria-hidden="true">
    {{ 'idle_session.warning' | translate: { seconds: secondsLeft() } }}
  </p>
  <p class="tw-sr-only" role="alert">{{ 'idle_session.warning_sr' | translate }}</p>

  <section class="tw-mt-8 tw-flex tw-justify-center tw-gap-3">
    <mh-core-lib-button
      [isSecondary]="true"
      [text]="'idle_session.logout_now' | translate"
      [customClass]="'!tw-w-auto tw-min-w-[160px] tw-whitespace-nowrap'"
      (clicked)="logoutNow.emit()">
    </mh-core-lib-button>
    <mh-core-lib-button
      [isPrimary]="true"
      [text]="'idle_session.stay_connected' | translate"
      [customClass]="'!tw-w-auto tw-min-w-[160px] tw-whitespace-nowrap'"
      (clicked)="stay.emit()">
    </mh-core-lib-button>
  </section>
</article>
